import { render, staticRenderFns } from "./News.vue?vue&type=template&id=6eab01df"
import script from "./News.vue?vue&type=script&setup=true&lang=ts"
export * from "./News.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./News.vue?vue&type=style&index=0&id=6eab01df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports